import { axios } from "services";

export const forgetPassword = async ({ email }) => {
  const response = await axios.post("/forgotpassword", { email });
  return response.data;
};

